import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/35443907/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Bee32 } from '@carbon/icons-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const DoDontExample = makeShortcode("DoDontExample");
const ArtDirection = makeShortcode("ArtDirection");
const Caption = makeShortcode("Caption");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`IBM’s pictograms are visual symbols used to represent ideas, objects, or
narratives. They can communicate messages at a glance, afford interactivity,
and simplify complex ideas. They draw from details found in the Plex typeface
and work well in presentations and marketing communications.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Usage</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Pictograms in Action</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Pictograms are illustrative and expressive and can live within a wide variety of
scales and environments whether digital or physical. As they are built on the same
grid as the rest of the IBM icon family, they share many of the same basic
principles but allow for more visual complexity and communication. You may use
pictograms to enhance the information you are conveying across various media.
It’s important to use pictograms sparingly but effectively throughout your design.`}</p>
    <img {...{
      "src": "/59e7f580cdd28efaf0dba287b9cf8679/13_Usage_0.svg",
      "alt": "Usage Example"
    }}></img>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="do" caption="Do treat pictograms as illustations and provide proper clearance" mdxType="DoDontExample">
          <img {...{
            "src": "/ff2ff265c1e6a1143550630ec36072bc/13_Usage_1_do.svg",
            "alt": "Do give proper space"
          }}></img>
        </DoDontExample>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="dont" caption="Don’t use pictograms as a replacement for UI icons, that is not their purpose." mdxType="DoDontExample">
          <img {...{
            "src": "/2f3ef83720e11cef69e158af1f72e9b7/13_Usage_2_dont.svg",
            "alt": "Don't replace UI icons with pictograms"
          }}></img>
        </DoDontExample>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="dont" caption="Don’t use any pictogram as a logo or in a lockup for product headers, merchandise or events." mdxType="DoDontExample">
          <img {...{
            "src": "/f8db0bb04f4ba35a84c02641e3f956ea/13_Usage_3_dont.svg",
            "alt": "Don't use pictogram as logo"
          }}></img>
        </DoDontExample>
      </Column>
    </Row>
    <h3 {...{
      "id": "sizing"
    }}>{`Sizing`}</h3>
    <p>{`Pictograms are used in a range of sizes, the minimum being 32px while the
maximum size may vary based on application. Use pictograms at their original
sizes or scale at accepted increments. You may need to adjust the stroke weight
accordingly to accommodate larger scales. For more information on scaling and
accessibility, see the section on mini units on the 2X Grid page.`}</p>
    <ArtDirection mdxType="ArtDirection">
      <img {...{
        "src": "/35b2049ad3d596de9fa831530d5bd396/14_Sizing_1-mobile_2.svg",
        "alt": "Different sized pictograms"
      }}></img>
      <img {...{
        "src": "/f110503ae70dbf63460015728dc5c94a/14_Sizing_1.svg",
        "alt": "Different sized pictograms"
      }}></img>
    </ArtDirection>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Icon size`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Stroke width`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Padding`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Live area`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Corner Radius`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`32px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.72px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`32px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2px`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`48px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.08px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.5px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3px`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.44px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`64px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4px`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`80px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.80px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2.5px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`80px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`5px`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`96px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2.16px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`96px`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`6px`}</td>
        </tr>
      </tbody>
    </table>
    <Caption mdxType="Caption">
  There is no set maximum to pictogram sizes. As you scale pictograms to larger
  sizes you may want to alter stroke weight to accommodate accessibility or
  environmental factors.
    </Caption>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
    <ResourceCard subTitle="2X Grid: The mini unit" aspectRatio="2:1" href="https://www.ibm.com/design/language/elements/2x-grid#the-mini-unit" mdxType="ResourceCard">
      <Bee32 mdxType="Bee32" />
    </ResourceCard>
  </Column>
    </Row>
    <h3 {...{
      "id": "alignment"
    }}>{`Alignment`}</h3>
    <p>{`Pictograms are optically aligned to the center of the icon grid within the
boundary box. Centering ensures all pictograms will be aligned correctly when
exported and used side by side.`}</p>
    <img {...{
      "src": "/091d38db953c300449b88b5b92efa8c2/15_Alignment_1.svg",
      "alt": null
    }}></img>
    <h3 {...{
      "id": "containers"
    }}>{`Containers`}</h3>
    <p>{`Pictograms can be represented in a circular or rectangular container calculated
based on the padding size.`}</p>
    <ArtDirection mdxType="ArtDirection">
      <img {...{
        "src": "/e4f3b9e8773f685c4b9c495eea311b45/16_Containers_1-mobile.svg",
        "alt": "Padding Example"
      }}></img>
      <img {...{
        "src": "/a541b8898d041bff168fa5d35f939982/16_Containers_1.svg",
        "alt": "Padding Example"
      }}></img>
    </ArtDirection>
    <ArtDirection mdxType="ArtDirection">
      <img {...{
        "src": "/f50b832b0e24d36a923a985174a27a7f/16_Containers_2-mobile.svg",
        "alt": "Padding Example"
      }}></img>
      <img {...{
        "src": "/5a9b44c3b98d71e444d64f089d120f6d/16_Containers_2.svg",
        "alt": "Padding Example"
      }}></img>
    </ArtDirection>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="do" caption="Do follow the clearance rule to allow for legibility and touch." mdxType="DoDontExample">
          <img {...{
            "src": "/2c7f9ac2e2df33bb3c0ea69b0c810d99/16_Containers_3_do.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="dont" caption="Don't collapse the pictogram clearance area." mdxType="DoDontExample">
          <img {...{
            "src": "/cbc2d788c78da3234e94a0a6851f5b91/16_Containers_4_dont.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="do" caption="Do use accepted shapes: circle or square for containers." mdxType="DoDontExample">
          <img {...{
            "src": "/44e737a7b01a1c26b2bd5959f9049c71/16_Containers_5_do.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="dont" caption="Don’t create new shapes for containers." mdxType="DoDontExample">
          <img {...{
            "src": "/589d9202d6501418201a3a9ec7d2fe9e/16_Containers_6_dont.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="do" caption="Do always optically center align pictograms in their containers." mdxType="DoDontExample">
          <img {...{
            "src": "/e56d46946bcc2ce742db174be18f1049/16_Containers_7_do.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="dont" caption="Don’t crop pictograms in container." mdxType="DoDontExample">
          <img {...{
            "src": "/9fb8cd1566d53244e1b6108dd6d8ccbb/16_Containers_8_dont.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
    </Row>
    <h3 {...{
      "id": "clearance"
    }}>{`Clearance`}</h3>
    <p>{`When designing with pictograms, all artwork should include minimum padding
based on 1/4 of the scaled grid size. The padding can be increased by increments of
1/4 grid units.`}</p>
    <ArtDirection mdxType="ArtDirection">
      <img {...{
        "src": "/824d636d7a1b5e954dae1c9dd4f68f36/17_Clearance_1-mobile.svg",
        "alt": null
      }}></img>
      <img {...{
        "src": "/7529b179acd3d4a2993d89856dbde78d/17_Clearance_1.svg",
        "alt": null
      }}></img>
    </ArtDirection>
    <Caption mdxType="Caption">Padding starts at the edge of the container shape.</Caption>
    <ArtDirection mdxType="ArtDirection">
      <img {...{
        "src": "/e0fa5155d59ccacc503cf1bc7a953ce1/17_Clearance_2-mobile.svg",
        "alt": null
      }}></img>
      <img {...{
        "src": "/d76c6af6cf2e61b89a8fd2ff6d7257cf/17_Clearance_2.svg",
        "alt": null
      }}></img>
    </ArtDirection>
    <Caption mdxType="Caption">Padding is the same for both circle and square containers.</Caption>
    <ArtDirection mdxType="ArtDirection">
      <img {...{
        "src": "/359ccba980275c0dda0e9f8de225683f/17_Clearance_3-mobile.svg",
        "alt": null
      }}></img>
      <img {...{
        "src": "/eb2a7a8d97852456bf6ebc2258e036f0/17_Clearance_3.svg",
        "alt": null
      }}></img>
    </ArtDirection>
    <Caption mdxType="Caption">
  Same spacing rules apply when using pictograms without containers.
    </Caption>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="do" caption="Do keep pictograms at scale and optically center in container when necessary." mdxType="DoDontExample">
          <img {...{
            "src": "/b544185ff0f27057439a62a49fdd312c/17_Clearance_4_do.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <DoDontExample type="dont" caption="Don’t resize pictograms outside of accepted proportions." mdxType="DoDontExample">
          <img {...{
            "src": "/fe257be861b88d1dfede81ab6edc27a0/17_Clearance_5_dont.svg",
            "alt": null
          }}></img>
        </DoDontExample>
      </Column>
    </Row>
    <h2 {...{
      "id": "pictograms-in-action"
    }}>{`Pictograms in Action`}</h2>
    <Row mdxType="Row">
      <Column colMd={6} colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAEDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAFw0OoZcmv/xAAZEAEAAwEBAAAAAAAAAAAAAAACAAEDExL/2gAIAQEAAQUC5mqPlrkZqVeOWDKt1P/EABcRAAMBAAAAAAAAAAAAAAAAAAIQESH/2gAIAQMBAT8BK3F//8QAGBEAAgMAAAAAAAAAAAAAAAAAARECEBL/2gAIAQIBAT8BhlF1/8QAGhABAQACAwAAAAAAAAAAAAAAAQACERASMf/aAAgBAQAGPwJdQdbwnUZcf//EABsQAQACAgMAAAAAAAAAAAAAAAEAEUFRcYHB/9oACAEBAAE/IVBDmOieom+EUNjMd9VzCIK2E//aAAwDAQACAAMAAAAQEN//xAAWEQADAAAAAAAAAAAAAAAAAAAQIUH/2gAIAQMBAT8QSgf/xAAWEQEBAQAAAAAAAAAAAAAAAABBEBH/2gAIAQIBAT8Q0aT/xAAbEAEAAwADAQAAAAAAAAAAAAABABEhMUFRYf/aAAgBAQABPxBWOChOZTIFcFrt1HJZ3b63z7AipMPFyviRRLOkYMAKrzP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Pictogram on Sign",
            "title": "Pictogram on Sign",
            "src": "/static/51ce652c2a5a264f4f73e025b9fc0516/c19dd/18_In-Context_1.jpg",
            "srcSet": ["/static/51ce652c2a5a264f4f73e025b9fc0516/c9de7/18_In-Context_1.jpg 288w", "/static/51ce652c2a5a264f4f73e025b9fc0516/6afcd/18_In-Context_1.jpg 576w", "/static/51ce652c2a5a264f4f73e025b9fc0516/c19dd/18_In-Context_1.jpg 1152w", "/static/51ce652c2a5a264f4f73e025b9fc0516/e1e74/18_In-Context_1.jpg 1728w", "/static/51ce652c2a5a264f4f73e025b9fc0516/4a138/18_In-Context_1.jpg 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colMd={6} colLg={4} mdxType="Column">
        <img {...{
          "src": "/3ecf544336e38e5d5dba9495f321af1c/18_In-Context_2.svg",
          "alt": "Pictogram as logo"
        }}></img>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colSm={4} colMd={4} colLg={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEEBQMG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB32XSPRIHOrfEJH//xAAbEAADAAIDAAAAAAAAAAAAAAACAwQAARATIP/aAAgBAQABBQLm5pLCOg+3DAWDqROvP//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAAIBAwUAAAAAAAAAAAAAAAECEQAQEiAhMkFR/9oACAEBAAY/ArrhtPdBXaQfbYsJFcZ0/wD/xAAbEAABBAMAAAAAAAAAAAAAAAABABARMSAhcf/aAAgBAQABPyFx4Rl2CsFdqL4QUmXRx//aAAwDAQACAAMAAAAQ8Mww/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhABAAEEAgMAAAAAAAAAAAAAAREAECExIFFBkaH/2gAIAQEAAT8QuuQYBkA0PiZ+UqIoBMlrL3qycaMw4h7GiaiMg6euP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Pictogram on hat",
            "title": "Pictogram on hat",
            "src": "/static/a6bba93e34f0d9e646bef6a915b02168/c19dd/18_In-Context_3.jpg",
            "srcSet": ["/static/a6bba93e34f0d9e646bef6a915b02168/c9de7/18_In-Context_3.jpg 288w", "/static/a6bba93e34f0d9e646bef6a915b02168/6afcd/18_In-Context_3.jpg 576w", "/static/a6bba93e34f0d9e646bef6a915b02168/c19dd/18_In-Context_3.jpg 1152w", "/static/a6bba93e34f0d9e646bef6a915b02168/3c63c/18_In-Context_3.jpg 1400w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colSm={4} colMd={4} colLg={4} mdxType="Column">
        <img {...{
          "src": "/aa872c759baf5237d6ab9d71a0f9cdca/18_In-Context_4.svg",
          "alt": "Pictogram on poster"
        }}></img>
      </Column>
      <Column colSm={4} colMd={4} colLg={4} mdxType="Column">
        <Row mdxType="Row">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.5%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAdM3MOSs/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAIBEBIR/9oACAEBAAEFAjStWYMLBw//xAAWEQADAAAAAAAAAAAAAAAAAAAQESH/2gAIAQMBAT8BiH//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAZEAABBQAAAAAAAAAAAAAAAAAQAAERISL/2gAIAQEABj8CWTTQP//EABsQAAICAwEAAAAAAAAAAAAAAAABESExQVFx/9oACAEBAAE/IZW8CWu36hnSxKwSJ//aAAwDAQACAAMAAAAQXB//xAAXEQADAQAAAAAAAAAAAAAAAAABEDFB/9oACAEDAQE/EBpV/8QAFhEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAECAQE/EKx//8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFBUf/aAAgBAQABPxBDWg1SAkbbwi2KFCjiPGEAAVz2/txu6z//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Pictogram on poster",
              "title": "Pictogram on poster",
              "src": "/static/a5d7912924f9dec9d2766aa9433b2075/c19dd/18_In-Context_5.jpg",
              "srcSet": ["/static/a5d7912924f9dec9d2766aa9433b2075/c9de7/18_In-Context_5.jpg 288w", "/static/a5d7912924f9dec9d2766aa9433b2075/6afcd/18_In-Context_5.jpg 576w", "/static/a5d7912924f9dec9d2766aa9433b2075/c19dd/18_In-Context_5.jpg 1152w", "/static/a5d7912924f9dec9d2766aa9433b2075/e1e74/18_In-Context_5.jpg 1728w", "/static/a5d7912924f9dec9d2766aa9433b2075/3b114/18_In-Context_5.jpg 2304w", "/static/a5d7912924f9dec9d2766aa9433b2075/8dedd/18_In-Context_5.jpg 2400w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </Row>
        <Row mdxType="Row">
          <img {...{
            "src": "/32e103b5683e18e950e73c9feacca823/18_In-Context_6.svg",
            "alt": "Pictogram example"
          }}></img>
        </Row>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colMd={6} colLg={8} mdxType="Column">
        <img {...{
          "src": "/54f5b8f0b21f5fab174546c6f1e0aa6a/18_In-Context_7.svg",
          "alt": "Pictogram on card"
        }}></img>
      </Column>
      <Column colMd={6} colLg={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIDBAX/xAAXAQADAQAAAAAAAAAAAAAAAAAAAgME/9oADAMBAAIQAxAAAAH0nPssrCzysppsB//EABkQAAIDAQAAAAAAAAAAAAAAAAACARATIv/aAAgBAQABBQK+iKzUyUyU/8QAFhEBAQEAAAAAAAAAAAAAAAAAAiBB/9oACAEDAQE/AUdj/8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQIBAT8BSP/EABkQAAMAAwAAAAAAAAAAAAAAAAAQMQERMv/aAAgBAQAGPwJ95LtQhD//xAAbEAEAAgIDAAAAAAAAAAAAAAABABAhMVFx8f/aAAgBAQABPyGwToOIUMvtRMeql//aAAwDAQACAAMAAAAQ1D+D/8QAFhEAAwAAAAAAAAAAAAAAAAAAASAh/9oACAEDAQE/EC1H/8QAFREBAQAAAAAAAAAAAAAAAAAAIEH/2gAIAQIBAT8QoP/EAB0QAQACAgIDAAAAAAAAAAAAAAEAERCRIVFhodH/2gAIAQEAAT8QGzLFEngBR6jy/fDjRjvNs7LaFP2z/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Pictogram on wallpaper",
            "title": "Pictogram on wallpaper",
            "src": "/static/2d10e1a01fe85aeacc9a367d6117250a/c19dd/18_In-Context_8.jpg",
            "srcSet": ["/static/2d10e1a01fe85aeacc9a367d6117250a/c9de7/18_In-Context_8.jpg 288w", "/static/2d10e1a01fe85aeacc9a367d6117250a/6afcd/18_In-Context_8.jpg 576w", "/static/2d10e1a01fe85aeacc9a367d6117250a/c19dd/18_In-Context_8.jpg 1152w", "/static/2d10e1a01fe85aeacc9a367d6117250a/e1e74/18_In-Context_8.jpg 1728w", "/static/2d10e1a01fe85aeacc9a367d6117250a/4a138/18_In-Context_8.jpg 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      